import { ROUTE } from "../../routes";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SharedPropsService from "../../SharedPropsService";
let counter = 0;
let currentRoute = "";
let hasNavigated = false;
export const needHelpAction = async (action, datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goBackAction = async (action, datastore, { goBack }) => {
    await goBack();
};
export const successCardAction = async (action, datastore, { navigateWithClear }) => {
    hasNavigated = true;
    navigateWithClear(ROUTE.BAJAJ_AGREEMENT_STEPPER);
};
export const agreeAction = async (action, datastore, { network, setDatastore, navigateWithClear }) => {
    const user = await SharedPropsService.getUser();
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id")) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    const response = await network.post(api.acceptBajajKfs, {
        applicationId: applicationId
    }, {
        headers: await getAppHeader(),
    });
    if (response.status === 200) {
        currentRoute = response?.updatedApplicationObj?.currentStepId;
        await setDatastore(ROUTE.BAJAJ_KFS, 'bajajKFS', {
            showSuccess: true,
            counter: counter++
        });
        setTimeout(() => {
            !hasNavigated && navigateWithClear(ROUTE.BAJAJ_AGREEMENT_STEPPER);
        }, 3000);
    }
    else {
        await setDatastore(ROUTE.BAJAJ_KFS, 'bajajKFS', {
            showLoading: false,
            counter: counter++
        });
    }
};
